var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotionThanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12125_6129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 17.9086 62.5914 0 40.5 0C18.4086 0 0.5 17.9086 0.5 40C0.5 62.0914 18.4086 80 40.5 80Z",
    fill: "url(#paint0_radial_12125_6129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4062 51.3125C67.2321 51.3125 72.7656 45.779 72.7656 38.9531C72.7656 32.1272 67.2321 26.5938 60.4062 26.5938C53.5804 26.5938 48.0469 32.1272 48.0469 38.9531C48.0469 45.779 53.5804 51.3125 60.4062 51.3125Z",
    fill: "url(#paint1_radial_12125_6129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 51.3125C27.2634 51.3125 32.7969 45.779 32.7969 38.9531C32.7969 32.1272 27.2634 26.5938 20.4375 26.5938C13.6116 26.5938 8.07812 32.1272 8.07812 38.9531C8.07812 45.779 13.6116 51.3125 20.4375 51.3125Z",
    fill: "url(#paint2_radial_12125_6129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2344 18.3906C5.43749 11.5 -0.671889 22.2343 3.04686 29.2812C3.04686 29.2812 4.96874 33.5625 12.8437 36.7343C14.8906 37.5625 17.3437 38.3125 20.2969 38.9375C20.6094 39 20.9531 38.9375 21.2187 38.7343C23.625 36.9375 25.5312 35.2031 27.0469 33.5937C32.8594 27.4062 32.7969 22.7031 32.7969 22.7031C33.1875 14.7656 23.125 7.59372 16.2344 18.3906Z",
    fill: "url(#paint3_linear_12125_6129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7657 18.3906C75.5625 11.5 81.6719 22.2343 77.9532 29.2812C77.9532 29.2812 76.0313 33.5625 68.1563 36.7343C66.1094 37.5625 63.6563 38.3125 60.7032 38.9375C60.3907 39 60.0469 38.9375 59.7813 38.7343C57.3751 36.9375 55.4688 35.2031 53.9532 33.5937C48.1407 27.4062 48.2032 22.7031 48.2032 22.7031C47.8126 14.7656 57.8751 7.59372 64.7657 18.3906Z",
    fill: "url(#paint4_linear_12125_6129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6563 19.9689C67.9219 17.0158 72.2188 16.3595 75.3125 18.7189C78.3907 21.0939 78.9532 26.0939 76.6875 29.047C74.4219 32.0001 70.0782 32.4845 67 30.1095C63.9063 27.7345 63.3907 22.922 65.6563 19.9689Z",
    fill: "url(#paint5_radial_12125_6129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 51.9217C32.5781 51.9217 24.9531 51.2185 17.8281 49.9217C17.1563 49.7967 16.5781 50.406 16.7188 51.0779C19.0313 62.0935 28.8125 70.3592 40.5156 70.3592C52.2188 70.3592 61.9844 62.0935 64.3125 51.0779C64.4531 50.406 63.875 49.8123 63.2031 49.9217C56.0469 51.2185 48.4219 51.9217 40.5 51.9217Z",
    fill: "url(#paint6_linear_12125_6129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9844 67.4531C48.5625 69.2969 44.6562 70.3438 40.5 70.3438C36.3438 70.3438 32.4375 69.2969 29.0156 67.4531C31.1719 64.1875 35.5156 61.9688 40.5 61.9688C45.4844 61.9688 49.8281 64.2031 51.9844 67.4531Z",
    fill: "url(#paint7_linear_12125_6129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1719 49.906C56.0469 51.2029 48.4219 51.906 40.5 51.906C32.5781 51.906 24.9531 51.2029 17.8281 49.906C17.1563 49.781 16.5781 50.3904 16.7188 51.0623C16.9531 52.156 17.25 53.2342 17.625 54.2654C24.1094 57.031 32 58.656 40.5 58.656C49.0156 58.656 56.9063 57.031 63.375 54.2654C63.75 53.2342 64.0625 52.156 64.2813 51.0623C64.4375 50.3904 63.8438 49.781 63.1719 49.906Z",
    fill: "url(#paint8_linear_12125_6129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39064 29.9531C2.43752 27.6875 1.78127 23.3906 4.14064 20.2968C6.50002 17.2031 11.5156 16.6562 14.4688 18.9218C17.4219 21.1875 17.9063 25.5312 15.5313 28.6093C13.1563 31.7031 8.34377 32.2187 5.39064 29.9531Z",
    fill: "url(#paint9_radial_12125_6129)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12125_6129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5 40) scale(42.6073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFEA7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#FFE273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#FFD361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFBF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFA629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#FF8804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#FF9C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#FFB53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#FFD766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED81"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12125_6129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.4094 38.9586) scale(13.7067 13.7067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#F78100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12125_6129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4394 38.9586) scale(13.7067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#F78100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12125_6129",
    x1: 15.3666,
    y1: 14.8771,
    x2: 21.5041,
    y2: 42.6382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60B15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12125_6129",
    x1: 65.6108,
    y1: 14.8854,
    x2: 59.4753,
    y2: 42.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60B15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12125_6129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.233 24.501) rotate(-167.53) scale(7.05172 7.05172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF9797",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9797",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12125_6129",
    x1: 40.4999,
    y1: 50.0698,
    x2: 40.4999,
    y2: 72.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12125_6129",
    x1: 40.4995,
    y1: 60.0781,
    x2: 40.4995,
    y2: 71.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12125_6129",
    x1: 40.4999,
    y1: 49.97,
    x2: 40.4999,
    y2: 59.3898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C4CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#DDE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#F0F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_12125_6129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.50553 25.5763) rotate(102.47) scale(7.05172 7.05172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF9797",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9797",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12125_6129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionThanks);
export default __webpack_public_path__ + "static/media/emotion-thanks.3b76dfa440766e100c8c344c9cdb0731.svg";
export { ForwardRef as ReactComponent };